import { useState, useEffect, useContext } from "react";
import {
  Paper,
  Typography,
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import SettingSwitch from "../components/SettingsSwitch";
import { EventContext } from "../../../../../contexts/EventContext";

const ExperienceSettings = ({ settings, handleChange }) => {
  const { pairingEvent } = useContext(EventContext);

  useEffect(() => {
    if (!pairingEvent) return;
    
  },[pairingEvent])

  const BreakAfterSelect = () => {
    if (["mixer", "dinner"].includes(pairingEvent?.pairingEventType))
      return null;
    const rounds = [];
    for (let i = 1; i <= pairingEvent.numberOfRounds; i++) {
      rounds.push(i);
    }

    return (
      <FormControl fullWidth variant="outlined" sx={{ width: 250, mb: 2 }}>
        <InputLabel sx={{ top: -5 }}>Break After Round</InputLabel>
        <Select
          value={settings.breakAfter}
          label="Break After"
          onChange={(e) => handleChange("breakAfter", e.target.value)}
          sx={{ height: 45 }}
        >
          <MenuItem value={0}>None</MenuItem>
          {rounds.map((r) => {
            return (
              <MenuItem key={`round-${r}`} value={r}>
                {r}
              </MenuItem>
            );
          })}
        </Select>
        <Typography variant="caption" sx={{ p: 1 }}>
          Choose the round after which you would like a break. Attendees will
          see a message that everyone is on a break.
        </Typography>
      </FormControl>
    );
  };
  return (
    <Paper sx={{ p: 3 }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        Attendee Experience
      </Typography>

      <Typography variant="caption" sx={{ display: "block", mb: 3 }}>
        Configure attendee requirements and what users can see or access during
        the event.
      </Typography>

      <Grid container spacing={1}>
        <Grid item xs={12}>
          <SettingSwitch
            label="Profile Photo Required"
            checked={settings.photoRequired}
            onChange={() =>
              handleChange("photoRequired", !settings.photoRequired)
            }
            description="Users must upload a profile photo before they can check into the event."
          />
        </Grid>

        <Grid item xs={12}>
          <SettingSwitch
            label="Show Date Selector"
            checked={settings.showDateSelector !== false}
            onChange={() =>
              handleChange(
                "showDateSelector",
                !(settings.showDateSelector !== false),
              )
            }
            description="When enabled, attendees on a break round see a button to choose a date (used for wildcard rounds). Disable to hide the button when wildcards are not in use."
          />
        </Grid>

        {/* Show Guest List */}
        <Grid item xs={6}>
          <SettingSwitch
            label="Show Guest List"
            checked={settings.showGuestList}
            onChange={() =>
              handleChange("showGuestList", !settings.showGuestList)
            }
            description=""
          />
        </Grid>

        <Grid item xs={6}>
          <SettingSwitch
            label="Show Notebook"
            checked={settings.showNotebook}
            onChange={() =>
              handleChange("showNotebook", !settings.showNotebook)
            }
            description=""
          />
        </Grid>

        {/* Break After Round */}
        <Grid item xs={12}>
          <BreakAfterSelect />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ExperienceSettings;
